/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Map Toolbar Vicinity Search Icon component.
 */
export const MapToolbarVicinitySearchIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M20.339 17.519C21.707 15.4521 22.2586 12.9507 21.8868 10.5001C21.5151 8.04942 20.2464 5.8242 18.3269 4.25596C16.4074 2.68773 13.9739 1.88825 11.4983 2.0126C9.02278 2.13695 6.68162 3.17625 4.92894 4.92894C3.17625 6.68162 2.13695 9.02278 2.0126 11.4983C1.88825 13.9739 2.68773 16.4074 4.25596 18.3269C5.8242 20.2464 8.04942 21.5151 10.5001 21.8868C12.9507 22.2586 15.4521 21.707 17.519 20.339' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M19 21C20.1046 21 21 20.1046 21 19C21 17.8954 20.1046 17 19 17C17.8954 17 17 17.8954 17 19C17 20.1046 17.8954 21 19 21Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M13.4102 13.4102L17.5902 17.5902' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default MapToolbarVicinitySearchIcon;
